import classNames from 'classnames';

import { ClassNameType } from 'interfaces';
import InfoType from '@atoms/Info/type';
import { twMerge } from 'tailwind-merge';

const defaultStyles = classNames(
  'text-tertiaryBlue',
  'bg-lightBlue-500',
  'flex',
  '!mt-5',
  '!p-4',
  'rounded',
);
const alertStyles = classNames(
  'bg-error-50',
  'text-error',
);

const styles = {
  component: (
    className: ClassNameType,
    type: InfoType = InfoType.INFO,
  ) => twMerge(classNames(
    defaultStyles,
    {
      [alertStyles]: type === InfoType.ALERT,
    },
  ), className),
  message: classNames(
    '!pl-4',
    'text-xs',
  ),
  alert: classNames(
    'text-tertiaryBlue',
    '!pl-4',
    'text-xs',
  ),
};

export default styles;
